import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'lp2-mkt-banner',
  templateUrl: './mkt-banner.component.html',
  styleUrls: ['./mkt-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MktBannerComponent {

  @Input() message: string;
  @Output() onClose = new EventEmitter();

  dismissBanner() {
    this.onClose.emit(true);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mkt-banner/mkt-banner.component.ts